<template>
    <section> 
       <ui-global-modals :closed-options="false"/>  
    </section>
</template>
<script>
    import { uiGlobalModals } from '@/components/ui-facilita/modals'
	export default {
        components: {
            uiGlobalModals
        },

        mounted() {
            const url = new URL(window.location.href)
            const params = url.searchParams.get('type') === 'launchday'
                ? {
                    type: url.searchParams.get('type'),
                    stage: url.searchParams.get('stage'),
                    status: url.searchParams.get('status'),
                    product_id: url.searchParams.get('product_id')
                }
                : null
            this.$root.$emit('modal-open-create-deal-modal', params)
        }
    }
</script>